/**
 * Replaces the secret in token-bearing URLs with `***` before a URL leaves the browser for a
 * third party (GA4 page views, Sentry events and breadcrumbs). Recruitment workflow step 5c.
 *
 * - `/invite/<token>` — the website invite page. Invite tokens never expire and let the holder
 *   set an unclaimed account's password, so they must never reach analytics or error logs.
 * - `/invites/<token>` — the API calls that page makes (`/public/invites/…`,
 *   `/candidates/auth/invites/…/claim`), which appear in Sentry's fetch breadcrumbs.
 * - `/reset-password/<token>`, `/verify-email/<token>` — the older single-use token pages,
 *   which leaked the same way before this.
 *
 * Mirrors the backend's `maskTokensInEmailContent` (email outbox). Query strings and fragments
 * are kept; only the path segment after the keyword is masked.
 */
const TOKEN_SEGMENTS = ['invite', 'invites', 'reset-password', 'verify-email'];

const TOKEN_PATH = new RegExp(`/(${TOKEN_SEGMENTS.join('|')})/[^/?#\\s"'<>]+`, 'g');

export function maskTokenUrl(url: string): string;
export function maskTokenUrl(url: string | undefined): string | undefined;
export function maskTokenUrl(url: string | undefined): string | undefined {
  if (!url) return url;
  return url.replace(TOKEN_PATH, '/$1/***');
}
